import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const ProcessesContainer = styled.div`
  display: grid;
  grid-template-columns: auto 9% repeat(4, 13%);
  margin-right: 28%;
  align-items: center;
  grid-column-gap: 10px;
  margin-top: 2px;
`;

export const ProcessesDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};

export const ProcessGroup = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
`;

export const ConfigurationsContainer = styled.div`
  display: grid;
  grid-template-columns: 190px 120px 15px;
  align-items: center;
  grid-column-gap: 20px;
  margin-top: 20px;
  .icon {
    display: flex;
    height: 32px;
    border-radius: 300px;
    font-weight: ${(props) => props.theme["@medium-font-weight"]};
    font-size: ${(props) => props.theme["@small-font-size"]};
    align-content: center;
    align-items: center;
    width: fit-content;
  }
  .hoverActionButton {
    cursor: pointer;
  }
  .actionButton {
    float: right;
    margin-top: -5px;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const DescriptionConfiguration = styled.h1`
  align-content: center;
  font-weight: 600;
  font-size: 16px;
  margin: 0;
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfigurationDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};
